<template>
  <v-app>
    <v-system-bar app window color="orange">
      <strong style="white-space: nowrap;">
        <v-btn text color="secondary">
          {{ usuario.ued }}
        </v-btn>
      </strong>
    </v-system-bar>
    <d-header
      v-model="drawer"
      title="Portal Colegios"
      :username="$store.getters.getUsername"
      :logged="true"
      :profile="profile"
      :show-side-icon="true"
    />
    <v-navigation-drawer v-model="drawer" fixed clipped app width="300">
      <v-list dense>
        <template v-for="(item, i) in items">
          <v-list-group v-if="item.children" :key="i" :value="item.active" no-action>
            <v-list-item slot="activator" class="px-0">
              <v-list-item-action class="mr-2">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-for="(child, j) in item.children" :key="i + '-' + j" :to="child.href" exact>
              <v-list-item-action v-if="child.icon" class="mr-2">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-badge v-if="child.count > 0" color="red">
                <span slot="badge">{{ child.count }}</span>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-badge>
              <v-list-item-content v-else>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item v-else :key="i" :to="item.href" exact>
            <v-list-item-action class="mr-2">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <template #append>
        <div class="text-center mb-5" style="font-size: 12px;">
          v{{ appVersion }}
        </div>
      </template>
    </v-navigation-drawer>

    <v-main>
      <v-container id="contenedor" fluid>
        <router-view />
      </v-container>
      <d-refresher />
      <d-notifier />
    </v-main>
    <d-profile jwt mensaje="Al presionar el botón Continuar se redireccionará a otro sitio cerrando la sesión actual." />
    <d-footer app />
  </v-app>
</template>

<script>
import Header from '@demre/client-common/src/components/header';
import Refresher from '@demre/client-common/src/components/jwt-refresher';
import Footer from '@demre/client-common/src/components/footer';
import Notifier from '@demre/client-common/src/components/notifier';
import Profile from '@demre/client-common/src/components/profile';

export default {
  components: {
    'd-header': Header,
    'd-refresher': Refresher,
    'd-footer': Footer,
    'd-notifier': Notifier,
    'd-profile' : Profile,
  },
  data: function() {
    return {
      drawer: true,
      profile: [
        { title: 'Cambiar contraseña y/o Email', icon: 'account_circle', href: { name: 'profile' } },
        { title: 'Salir', icon: 'power_settings_new', href: { name: 'logout' }}
      ],
    };
  },
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION;
    },
    items() {
      return [
        {icon: 'home', text: 'Registro', href: { name: 'registro' } },
        {icon: 'list', text: `Nómina de Estudiantes`, href: { name: 'nomina' } },
        {icon: '$chart_bar', text: 'Pilotaje', href: { name: 'pilotaje' } },
        {icon: 'list', text: 'Resultados' , active: this.$route.name == 'puntajesPaes' || this.$route.name == 'resultadoSeleccion' || this.$route.name == 'resultadosPilotaje',
          children: [
            { icon: '$clipboard_list_outline', text: 'PAES', href: { name: 'puntajesPaes' }, active: false },
            { icon: '$clipboard_list_outline', text: 'Selección', href: { name: 'resultadoSeleccion' }, active: false },
            { icon: '$clipboard_list_outline', text: 'Pilotaje', href: { name: 'resultadosPilotaje' }, active: false },
          ]
        },
        {icon: 'file_download', text: 'Descargas', href: { name: 'descargas'} },
        {icon: 'account_balance', text: 'Ficha Caracterización', href: { name: 'caracterizacionLocal' } },
      ]
    },
    usuario() {
      return this.$store.state.usuario;
    }
  },

};
</script>

<style>
  .my-upper input {
    text-transform: uppercase
  }
</style>
